var DEFAULT_ID_SCOPE = 'id__';
var ID_MAP = {};
export function generateId() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ID_SCOPE;

  if (ID_MAP[scope] === undefined) {
    ID_MAP[scope] = 0;
  }

  var id = ID_MAP[scope]++;
  return "".concat(scope).concat(id);
}
export function resetId() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ID_SCOPE;
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  ID_MAP[scope] = value;
}